import { object } from 'yup'
import { DonorInfoFormData } from '../components/donor-info-fields'
import { makeOrderContactValidationSchema } from 'modules/order/state/contact/contact-utils'
import { makeOrderAddressValidationSchema } from 'modules/order/state/address/address-utils'

export const makeDonorInfoValidationSchema = (isBillingAddressRequired = false) => {
  // Reuse existing validation schemas
  const contactSchema = makeOrderContactValidationSchema(false) // phone not required
  const addressSchema = makeOrderAddressValidationSchema()

  const baseSchema = {
    // From contact: email, firstName, lastName
    email: contactSchema.fields.email,
    firstName: contactSchema.fields.firstName,
    lastName: contactSchema.fields.lastName,
  }

  // When billing address is required, these fields will be validated in the DonorInfo component
  if (!isBillingAddressRequired) {
    return object({
      ...baseSchema,
      // From address: country, zipCode
      country: addressSchema.fields.country,
      zipCode: addressSchema.fields.zipCode,
    })
  }

  return object(baseSchema)
}

// Default values for the form
export const makeDonorInfoDefaultValues = (
  isBillingAddressRequired = false,
): Partial<DonorInfoFormData> => {
  const baseValues = {
    email: '',
    firstName: '',
    lastName: '',
  }

  // Only include address fields when billing address is NOT required
  if (!isBillingAddressRequired) {
    return {
      ...baseValues,
      country: 'US', // Default to US
      zipCode: '',
    }
  }

  return baseValues
}
